import { ColumnsType, InfiniteTable } from '@/components/_common';
import EyeIcon from '@/components/_common/EyeIcon';
import { useWorkOrderAuditSales } from '@/core/domain/workorder/AuditData/AuditData.hooks';
import {
  WorkOrderAuditDataSalesRequest,
  WorkOrderAuditDataSalesResponse,
} from '@/core/domain/workorder/AuditData/AuditData.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Card } from 'antd';

interface Props {
  queryParams?: WorkOrderAuditDataSalesRequest;
}

export default function AuditSalesTable({ queryParams }: Props) {
  const workOrderAuditSales = useWorkOrderAuditSales({
    ...queryParams,
  });
  const workOrderAuditSalesData = flatInfiniteData(workOrderAuditSales.data);

  const columns: ColumnsType<WorkOrderAuditDataSalesResponse> = [
    {
      title: 'Venda',
      dataIndex: 'saleCode',
      key: 'saleCode',
    },
    {
      title: 'Cód. Interno',
      dataIndex: 'internalCode',
      key: 'internalCode',
      render: (value) => value || '-',
    },
    {
      title: 'Cód. fabricante',
      dataIndex: 'manufacturingCode',
      key: 'manufacturingCode',
      render: (value) => value || '-',
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Visualizar',
      key: 'visualizar',
      align: 'center',
      width: 100,
      render: (_, row) => (
        <EyeIcon
          redirect={`/app/movements/directSale/${row.saleId}/general`}
          target="_blank"
          disabled={!row.saleId}
        />
      ),
    },
  ];

  return (
    <Card type="inner" style={{ borderRadius: 10 }}>
      <InfiniteTable
        columns={columns}
        dataSource={workOrderAuditSalesData}
        loading={workOrderAuditSales.isFetching}
        scroll={{ x: true }}
        fetchNextPage={workOrderAuditSales.fetchNextPage}
        hasNextPage={workOrderAuditSales.hasNextPage}
      />
    </Card>
  );
}
